module.exports = __webpack_public_path__ + "assets/images/ios_first_install-23847597df54c80751db20f7ade03067.webm";